import { takeEvery,takeLatest,fork, put, all, call } from "redux-saga/effects"
import { registerUserSuccessful, registrationError } from "./actions";
import { postLogin } from "../../../helpers/backend_helper";
import { REGISTER_USER, UPDATE_USER } from "./actionTypes";
import { getAllUSer } from "../../actions";

function* registerUser  (data)  {
    try {
      const payload={
        act: "user",
        subact: "create",
        info:data.payload
      }
      const response =  yield call(postLogin(payload));
      if (response.message.includes("success")) {
        yield put(registerUserSuccessful(response))
      }
    } catch (error) {
       yield call(registrationError(error));
    }
  };


function* updateUser  (data)  {
    try {
      const payload={
        act: "user",
        subact: "updateuser",
        info:data.payload
      }
      const response =  yield call(postLogin(payload));
      if (response.message.includes("success")) {
        yield call(getAllUSer)
}
    } catch (error) {
    }
  };

function* accountSaga() {
     yield takeLatest(REGISTER_USER, registerUser);
     yield takeEvery(UPDATE_USER, updateUser);


}




export default accountSaga


